import { hasRiskReviewValue } from "./riskReviewValueNormalizer";

export const sortBySequence = (items = []) =>
  [...items].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

export const getSectionCompletion = ({ section, values, required = {}, visibility = {} }) => {
  const visibleRequiredFields = (section.fields || []).filter(
    (field) => visibility[field.code] !== false && required[field.code],
  );

  const complete = visibleRequiredFields.filter((field) =>
    hasRiskReviewValue(values?.[field.code]),
  ).length;

  return {
    complete,
    total: visibleRequiredFields.length,
    isComplete: complete === visibleRequiredFields.length,
  };
};
